<button
  *cignaTabLabel
  cignaTabButton
  [ngStyle]="width !== '' ? { width: width } : {}"
  [ngClass]="returnColorClass()"
  (click)="onClick($event)"
>
  {{ label }}
</button>

<ng-template #contentTemplate><ng-content></ng-content></ng-template>
